import request from '@/utils/request'


// 查询机构教师列表
export function listTeacher(query) {
  return request({
    url: '/teacher/teacher/list',
    method: 'get',
    params: query
  })
}

// 查询机构教师分页
export function pageTeacher(query) {
  return request({
    url: '/teacher/teacher/page',
    method: 'get',
    params: query
  })
}

// 查询机构教师详细
export function getTeacher(data) {
  return request({
    url: '/teacher/teacher/detail',
    method: 'get',
    params: data
  })
}

// 新增机构教师
export function addTeacher(data) {
  return request({
    url: '/teacher/teacher/add',
    method: 'post',
    data: data
  })
}

// 修改机构教师
export function updateTeacher(data) {
  return request({
    url: '/teacher/teacher/edit',
    method: 'post',
    data: data
  })
}

// 删除机构教师
export function delTeacher(data) {
  return request({
    url: '/teacher/teacher/delete',
    method: 'post',
    data: data
  })
}
